export default function s3Reducer(state, action) {
  switch(action.type){
    // 这里要保持thumbnail和slide_overview这两个key，因为是Metadata.s3里面写死的
    case "thumbnail":
      return {
        ...state,
        thumbnail: action.value?.thumbnail
      }
    case "slide_overview":
      return {
        ...state,
        slide_overview: action.value?.slide_overview
      }
    default:
      throw new Error(`Unknown action.type: ${action.type}`)
  }
}